import React, {useEffect, useState} from 'react';
import {Table, Divider, Row, Col, Tag, Button, Modal} from 'antd';
import {useNavigate, useParams} from 'react-router-dom';
import {useSelector} from 'react-redux';
import useDebouncedCallback from '../../../hooks/useDebounce';
import {
  CronJobStatus,
  // formatDataForScheculer,
  PageSizeArray,
  PaginationPosition,
  ReturnNAOnEmpty,
  renderTemplateChapterIdsCell,
  renderTemplateRunStatus,
} from '../../../Util/commonUtility.js';
import DynamicSearchForm from '../../CommonComponents/DynamicSearch';
import AdminActionsDropdown from '../../CommonComponents/AdminActionsDropdown/AdminActionsDropdown';
import AdminViewDetailsDrawer from '../../CommonComponents/AdminViewDetailsDrawer/index';
import HeaderSearchCard from '../../CommonComponents/HeaderSearchCard/index';
import useLocalization from '../../../Localization';
import moment from 'moment';

const AllEmailSchedulerComponent = (props) => {
  const {id} = useParams();
  const {ApplicationString} = useLocalization();
  const navigate = useNavigate();
  const editTemplateParams = 'updateTemplate';
  const editTeplateSchedulerParams = 'updateTemplateSchedule';
  const [expanded, setExpanded] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerRecord, setDrawerRecord] = useState(null);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewHtml, setPreviewHtml] = useState('');

  const ps = useSelector(
    ({pageSizes}) => pageSizes.pageSizes?.eventEmailTemplates,
  );

  const {
    allEventEmails,
    fetchEventEmails,
    paging,
    handlePaginationChange,
    deleteEventEmail,
    handleEditTemplate,
    sortParams,
    handleTableChange,
    searchValues,
    eventsList,
    setFetching,
    fetching,
    setEventsList,
    chaptersList,
  } = props;

  useEffect(() => {
    if (searchValues) setExpanded(true);
  }, [searchValues]);

  useEffect(() => {
    window.scrollTo({top: 0, behavior: 'smooth'});
  }, []);

  const toggleExpand = () => setExpanded((s) => !s);

  const showDrawer = (record) => {
    setDrawerRecord(record);
    setDrawerOpen(true);
  };
  const closeDrawer = () => setDrawerOpen(false);

  const openPreviewModal = (html) => {
    setPreviewHtml(html || '');
    setPreviewVisible(true);
  };
  const closePreviewModal = () => setPreviewVisible(false);

  // Match edit form + API parseScheduleDate: date-only values must use UTC calendar parts (see moment.utc).
  const formatScheduleDate = (value) =>
    value ? moment.utc(value).format('YYYY-MM-DD') : 'N/A';

  const formatDate = (value) =>
    value ? moment(value).format('YYYY-MM-DD') : 'N/A';

  const defaultStatusTag = (cronJobStatus) => {
    switch (+cronJobStatus) {
      case CronJobStatus.RUN_SUCCESSFULLY:
        return <Tag color='green'>Run successfully</Tag>;
      case CronJobStatus.FAILED:
        return <Tag color='red'>Failed to run schedule</Tag>;
      default:
        return <Tag color='purple'>Schedule not initiated yet</Tag>;
    }
  };

  const statusTag = (record) => {
    // Attendance reminders now use the same schedule status as other emails.
    // The 7-day / alternate "next schedule" status is disabled.
    // if (record?.email_template_type === 'Event Attendance Reminder') {
    //   const cronJobStatus = +record?.cron_job_status;
    //
    //   if (!record?.schedule_date) {
    //     if (cronJobStatus === CronJobStatus.RUN_SUCCESSFULLY) {
    //       return <Tag color='green'>Run successfully</Tag>;
    //     }
    //
    //     if (cronJobStatus === CronJobStatus.FAILED) {
    //       return <Tag color='red'>Failed to run schedule</Tag>;
    //     }
    //
    //     return <Tag color='purple'>Schedule not initiated yet</Tag>;
    //   }
    //
    //   if (cronJobStatus === CronJobStatus.FAILED) {
    //     return <Tag color='red'>Failed to run schedule</Tag>;
    //   }
    //
    //   const scheduleState = record?.attendance_schedule_state;
    //   const lastScheduledDate = scheduleState?.last_scheduled_date;
    //   const nextScheduledDate = scheduleState?.next_scheduled_date;
    //
    //   if (
    //     scheduleState?.schedule_meta?.last_run_reason ===
    //     'no_registered_recipients'
    //   ) {
    //     return (
    //       <Tag color='green' style={{whiteSpace: 'normal', lineHeight: '20px'}}>
    //         Run successfully (No registered attendee was there)
    //       </Tag>
    //     );
    //   }
    //
    //   if (
    //     scheduleState?.is_completed &&
    //     lastScheduledDate &&
    //     !nextScheduledDate
    //   ) {
    //     return <Tag color='green'>Run successfully</Tag>;
    //   }
    //
    //   if (lastScheduledDate && nextScheduledDate) {
    //     return (
    //       <Tag color='blue' style={{whiteSpace: 'normal', lineHeight: '20px'}}>
    //         {`Ran at ${formatDataForScheculer(
    //           lastScheduledDate,
    //         )}, next schedule at ${formatDataForScheculer(nextScheduledDate)}`}
    //       </Tag>
    //     );
    //   }
    //
    //   return <Tag color='purple'>Schedule not initiated yet</Tag>;
    // }

    return defaultStatusTag(record?.cron_job_status);
  };
  const eventEmailFilters = [
    {
      label: 'Event Id',
      name: 'event_id',
      type: 'event_id',
      options: eventsList,
      initialValue: [],
    },
    {label: 'Subject', name: 'subject', type: 'subject', initialValue: ''},
    {
      label: 'Email Template Type',
      name: 'email_template_type',
      type: 'email_template_type',
      initialValue: '',
    },
    {
      label: 'Status',
      name: 'schedule_date',
      type: 'dropdown',
      options: [
        {label: 'Scheduled', value: 'scheduled'},
        {label: 'Not Scheduled', value: 'not scheduled'},
      ],
      initialValue: [],
    },
  ];

  const DrawerContent = () => {
    if (!drawerRecord) return null;

    const {
      subject,
      email_template_type,
      schedule_date,
      email_template_body,
      created_at,
      event,
      local_chapter_ids,
      mail_preference_chapter_ids,
    } = drawerRecord || {};

    return (
      <div>
        <Row>
          <Col span={24}>
            <div style={{fontWeight: 600, marginBottom: 8}}>Subject</div>
            <div>{ReturnNAOnEmpty(subject)}</div>
          </Col>
        </Row>
        <Divider />

        <Row>
          <Col span={12}>
            <div style={{fontWeight: 600, marginBottom: 8}}>
              Event Template Type
            </div>
            <div>{ReturnNAOnEmpty(email_template_type)}</div>
          </Col>
          <Col span={12}>
            <div style={{fontWeight: 600, marginBottom: 8}}>Status</div>
            <div>
              {renderTemplateRunStatus(statusTag(drawerRecord), drawerRecord)}
            </div>
          </Col>
        </Row>
        <Divider />

        <Row>
          <Col span={12}>
            <div style={{fontWeight: 600, marginBottom: 8}}>Scheduled Date</div>
            <div>{formatScheduleDate(schedule_date)}</div>
          </Col>

          <Col span={12}>
            <div style={{fontWeight: 600, marginBottom: 8}}>Created At</div>
            <div>{formatDate(created_at)}</div>
          </Col>
        </Row>
        <Divider />

        <Row>
          <Col span={12}>
            <div style={{fontWeight: 600, marginBottom: 8}}>Local Chapter</div>
            <div>
              {renderTemplateChapterIdsCell(
                local_chapter_ids,
                chaptersList,
                email_template_type,
                'Local Chapter',
              )}
            </div>
          </Col>
          <Col span={12}>
            <div style={{fontWeight: 600, marginBottom: 8}}>Mail Preference</div>
            <div>
              {renderTemplateChapterIdsCell(
                mail_preference_chapter_ids,
                chaptersList,
                email_template_type,
                'Mail Preference',
              )}
            </div>
          </Col>
        </Row>
        <Divider />

        <Row>
          <Col span={24}>
            <div style={{fontWeight: 600, marginBottom: 8}}>Event Name</div>
            <div>{event?.name ? `${event.name} (ID: ${event.id})` : 'N/A'}</div>
          </Col>
        </Row>
        <Divider />
        <Row>
          <Col span={24}>
            <div style={{fontWeight: 600, marginBottom: 8}}>Event Place</div>
            <div>{event?.place ? `${event.place}` : 'N/A'}</div>
          </Col>
        </Row>

        <Divider />

        <Row>
          <Col span={24}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}>
              <div style={{fontWeight: 600}}>Email Template Body</div>
              <div>
                <Button
                  size='small'
                  onClick={() => openPreviewModal(email_template_body)}>
                  View Full Template
                </Button>
              </div>
            </div>
            <div style={{marginTop: 8}}>
              {/* Small preview (stripped) */}
              <div
                style={{
                  maxHeight: 180,
                  overflow: 'auto',
                  border: '1px solid #f0f0f0',
                  padding: 8,
                }}
                dangerouslySetInnerHTML={{
                  __html: email_template_body || '<p>N/A</p>',
                }}
              />
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: '4%',
      sorter: true,
    },

    {
      title: 'Event Name',
      dataIndex: 'event',
      key: 'event',
      width: '10%',
      render: (event) => (event?.name ? ReturnNAOnEmpty(event.name) : 'N/A'),
      sorter: false,
    },

    {
      title: 'Subject',
      dataIndex: 'subject',
      key: 'subject',
      width: '10%',
      render: (text) => ReturnNAOnEmpty(text),
      sorter: true,
    },
    {
      title: 'Schedule Date',
      dataIndex: 'schedule_date',
      key: 'schedule_date',
      width: '10%',
      render: (val) => formatScheduleDate(val),
      sorter: true,
    },
    {
      title: 'Email Template Type',
      dataIndex: 'email_template_type',
      key: 'email_template_type',
      width: '18%',
      render: (text) => ReturnNAOnEmpty(text),
      sorter: true,
    },
    {
      title: 'Local Chapter',
      dataIndex: 'local_chapter_ids',
      key: 'local_chapter_ids',
      width: '10%',
      render: (chapterIds, record) =>
        renderTemplateChapterIdsCell(
          chapterIds,
          chaptersList,
          record?.email_template_type,
          'Local Chapter',
        ),
      sorter: false,
    },
    {
      title: 'Mail Preference',
      dataIndex: 'mail_preference_chapter_ids',
      key: 'mail_preference_chapter_ids',
      width: '10%',
      render: (chapterIds, record) =>
        renderTemplateChapterIdsCell(
          chapterIds,
          chaptersList,
          record?.email_template_type,
          'Mail Preference',
        ),
      sorter: false,
    },
    {
      title: 'Status',
      dataIndex: 'cron_job_status',
      key: 'cron_job_status',
      width: '18%',
      render: (_, record) => renderTemplateRunStatus(statusTag(record), record),
      sorter: true,
    },

    {
      title: '',
      key: 'action',
      width: '6%',
      fixed: 'right',
      render: (_, record) => (
        <AdminActionsDropdown
          record={record}
          editBool={false}
          deleteBool={true}
          viewBool={true}
          handleView={showDrawer}
          resource='events_email_scheduler'
          handleDeleteClick={deleteEventEmail}
          text='Event Template Scheduler'
          handleEditTemplate={(stateValue, id) => {
            handleEditTemplate(stateValue);
            navigate(
              `/admin/eventEmailTemplatesScheduler/update/${id}/${record?.event_id}/${editTemplateParams}`,
            );
          }}
          handleEditSchedule={(stateValue, id) => {
            handleEditTemplate(stateValue);
            navigate(
              `/admin/eventEmailTemplatesScheduler/update/${id}/${record?.event_id}/${editTeplateSchedulerParams}`,
            );
          }}
        />
      ),
    },
  ];

  columns.forEach((column) => {
    if (column.key !== 'action') {
      column.sortOrder =
        sortParams?.field === column.dataIndex ||
        sortParams?.field === column.key
          ? sortParams.order
          : false;
    }
  });

  const debouncedHandlePaginationChange = useDebouncedCallback(
    handlePaginationChange,
    1000,
  );
  const debouncedTableChange = useDebouncedCallback(handleTableChange, 1000);

  return (
    <div className='main-container'>
      <AdminViewDetailsDrawer
        content={DrawerContent}
        visible={drawerOpen}
        text={'Event Email Templates'}
        onCloseDrawer={closeDrawer}
        editNavigate={`/admin/eventEmailTemplatesScheduler/update/${drawerRecord?.id}`}
      />

      <Modal
        title='Email Template Preview'
        visible={previewVisible}
        onCancel={closePreviewModal}
        footer={null}
        width={900}
        bodyStyle={{maxHeight: '70vh', overflow: 'auto'}}>
        <div
          dangerouslySetInnerHTML={{__html: previewHtml || '<p>No content</p>'}}
        />
      </Modal>

      <HeaderSearchCard
        resource='event-email-templates'
        toggleClick={toggleExpand}
        title='All Email Scheduler'
        expanded={expanded}
        showAddButton={false}
      />

      {expanded && (
        <DynamicSearchForm
          columns={eventEmailFilters}
          onSearch={(values) => fetchEventEmails(values)}
          savedFilteredValues={searchValues}
          title={'eventEmailSchedulers'}
          eventsList={eventsList}
          setEventsList={setEventsList}
          fetching={fetching}
          setFetching={setFetching}
        />
      )}

      <div className='listing-container'>
        <Table
          bordered
          className='admin-table'
          columns={columns}
          onChange={debouncedTableChange}
          dataSource={allEventEmails}
          rowKey={(record) => record.id}
          scroll={{x: columns.length * 150}}
          sticky={true}
          pagination={{
            onChange: debouncedHandlePaginationChange,
            current: paging.page,
            total: paging.totalCount,
            pageSize: ps || paging.pageCount,
            pageSizeOptions: PageSizeArray,
            showSizeChanger: true,
            showQuickJumper: true,
            onShowSizeChange: (page, pageSize) => {
              handlePaginationChange(page, pageSize);
            },
            showTotal: (total, range) => `Total ${total} items`,
            position: [PaginationPosition],
          }}
        />
      </div>
    </div>
  );
};

export default AllEmailSchedulerComponent;
